export default __webpack_public_path__ + "static/media/SUA PRÓXIMA COMPRA_.07e26194.png";